import { render } from "./Host.vue?vue&type=template&id=faadabb6"
import script from "./Host.vue?vue&type=script&lang=js"
export * from "./Host.vue?vue&type=script&lang=js"

import "./Host.vue?vue&type=style&index=0&id=faadabb6&lang=css"

import exportComponent from "/var/www/calc/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__